import { colors } from "@mui/material";

const AppColors = {
  purple: "#8850EF",
  textGray: "#838383",
  appWhite: "#FFFFFF",
  darkPurple: "#2D1B50",
  textPurple: "#4B0082",
  lightPurple: "#E6E6FA",
  sidebar: {
    bg: `#3e4a57`,
    color: "#fff",
    hoverBg: colors.pink["400"],
    activeBg: colors.pink["600"],
  },
  topbar: {
    bg: "#fff",
    color: "#000",
  },
  mainBg: "#2e3742",
};

export default AppColors;
